'use client';

import { FC } from 'react';

import GridView from '@/components/BlogPage/PostsList/GridView';
import { BlogPostDto } from '@/components/BlogPage/types';

interface Props {
	posts: BlogPostDto[];
}

const AuthorsPosts: FC<Props> = ({ posts }) => {
	if (!posts.length) return null;

	return (
		<section>
			<GridView posts={posts} />
		</section>
	);
};

export default AuthorsPosts;
